import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Header } from '@rossum/components/header/Header';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { Stack } from '@rossum/ui/material';
import { HeaderTabs } from '../../../components/NavBar/HeaderTabs';
import { tabs } from '../../../components/NavBar/navigationStructure';
import { auroraEngineConfigEnabledSelector } from '../../../redux/modules/organizationGroup/selectors';
import { DedicatedEnginesList } from '../components/DedicatedEnginesList';
import { ExtractorsList } from '../components/ExtractorsList';
import { GenericEnginesList } from '../components/GenericEnginesList';
import { SplittersList } from '../components/SplittersList';

export const EngineListPage = () => {
  const intl = useIntl();
  const auroraConfigEnabled = useSelector(auroraEngineConfigEnabledSelector);

  return (
    <PageLayout
      renderHeader={params => (
        <Header
          {...params}
          title={intl.formatMessage({
            id: 'features.engines.header.title.main',
          })}
          description={intl.formatMessage({
            id: 'features.engines.header.description.main',
          })}
          tabs={
            <HeaderTabs
              menuItems={
                tabs.find(tab => tab.name === 'automation')?.menu ?? []
              }
              value="aiEngines"
            />
          }
          breadcrumbs={null}
        />
      )}
    >
      <Stack spacing={8} p={4}>
        {auroraConfigEnabled && <ExtractorsList />}
        {auroraConfigEnabled && <SplittersList />}
        <DedicatedEnginesList />
        <GenericEnginesList />
      </Stack>
    </PageLayout>
  );
};
